/* istanbul ignore file */
import { SVGProps } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
const SvgElem = (props: SVGProps<SVGSVGElement>) => (
<svg
 width="100%"
    height="100%"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
  <g>
    <g id="Layer_1">
      <g>
        <g id="Group_1959">
          <g clipPath="url(#clippath-0)">
            <g id="Group_1959-2">
              <path id="Path_3673" fill="currentColor" d="M45.6,13.8H2.4c-.7,0-1.3.6-1.3,1.3v17.8c0,.7.6,1.3,1.3,1.3h43.2c.7,0,1.3-.6,1.3-1.3V15.1c0-.7-.6-1.3-1.3-1.3M44.3,31.6H3.7v-15.2h40.6v15.2Z"/>
            </g>
          </g>
        </g>
        <g id="Group_1961">
          <g clipPath="url(#clippath-1)">
            <g id="Group_1960">
              <path id="Path_3674" fill="currentColor" d="M9.2,19c-.4-.3-.9-.4-1.3-.4h-1.3v1.1h1.3c.3,0,.6.2.7.5v7.3c0,.3-.4.6-.7.5h-1.3v1h1.3c.5,0,.9-.1,1.3-.4.4.3.9.4,1.3.4h1.3v-1.1h-1.4c-.3,0-.6-.2-.7-.5v-7.3c0-.3.4-.6.7-.5h1.3v-1h-1.3c-.5,0-.9.1-1.3.4"/>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
   <defs>
    <clipPath id="clippath-0">
      <rect fill="none" x="1.1" y="13.8" width="45.7" height="20.3"/>
    </clipPath>
    <clipPath id="clippath-1">
      <rect fill="none" x="6.6" y="18.6" width="5.4" height="10.5"/>
    </clipPath>
  </defs>
</svg>
);
export const InputField = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid={'InputFieldIcon'}
    >
      <SvgElem {...props} />
    </SvgIcon>
  );
};
